/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getCachedUserToken } from '../../../../utilities/caching';
import { gotoUrlEnvironment } from '../../../../utilities/helpers';
import { ACCOUNT_REGIONS } from '../../../../utilities/constants';
import { cardSettingsScreens } from '../constants';
import { SET_PIN_DEEPLINK_QUERY_PARAMS, SET_PIN_DEEPLINK_SESSION_KEYS } from './constants';

const SetPinDeeplink = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const appId = searchParams.get(SET_PIN_DEEPLINK_QUERY_PARAMS.APP_ID);
    const pathname = location.pathname.replace(/\/+$/, '');

    const isRowApp = appId === process.env.REACT_APP_ROW_APP_NAME;
    const isUsApp = appId === process.env.REACT_APP_US_APP_NAME;
    const isValidAppId = isRowApp || isUsApp;
    const isOnRowHost = window.location.hostname === process.env.REACT_APP_FE_BASE_HOSTNAME;
    const isOnUsHost = window.location.hostname === process.env.REACT_APP_US_FE_BASE_HOSTNAME;

    if (isValidAppId && !(isRowApp && isOnRowHost) && !isOnUsHost) {
      gotoUrlEnvironment(ACCOUNT_REGIONS.US, `${pathname.slice(1)}${location.search}`);
      return;
    }

    const token = getCachedUserToken();
    if (!token) {
      sessionStorage.setItem(
        SET_PIN_DEEPLINK_SESSION_KEYS.RETURN_URL,
        `${pathname}${location.search}`
      );
      history.push('/onboarding/login');
      return;
    }

    history.replace('/dashboard/card/settings', {
      initScreen: cardSettingsScreens.VERIFY_PASSWORD,
    });
  }, []);

  return null;
};

export default SetPinDeeplink;
